const modalsRu = {
  requests: "Какие запросы разберем?",
  howIsGoingCons: "Как проходит консультация?",
  buy: "Купить",

  personal: {
    title: "Целостная личная матрица",

    firstStep:
      "Первая ступень Матрицы Судьбы является идеальной базой для старта в познании себя и своих глубинных процессов. Матрица отвечает на большинство вопросов, таких как:",
    stepsList1: "Какие у меня сильные качества?",
    stepsList2: "Какое моё предназначениe?",
    stepsList3: "Какие у меня таланты?",
    stepsList4: "Как мне реализовать себя?",
    stepsList5: "Как заработать деньги?",
    stepsList6: "Как построить личную жизнь?",
    stepsList7: "Куда пойти учиться?",
    stepsList8: "Могу ли я открыть свой бизнес?",
    stepsList9: "Почему сложные отношения с родными? И т.д.",
    desc1:
      "Также, матрица расскажет какие склонности, изюминки и сверхспособности заложены в вашей личности. Возможные трудности, испытания и негативные установки с прошлых воплощений, которые нужно проработать и преобразовать в ресурс.",
    desc2:
      "В дальнейшем можно наслаивать на эту базу изучения своей личности с помощью других методов, а также спускаться на более глубинные уровни своей души. И выходить на новые уровни понимания и осознанности.",
    desc3:
      "Это самая глубокая и самая фундаментальная трансформация в вашей жизни, которая разделяет жизнь на «до» и «после».",

    videoMeeting:
      "Видеовстреча до 3 часов + трансформация 60-90 дней по индивидуальной программе",
    additionalInfo1:
      "+ Дополнительно входит разбор совместимости с 1 человеком",
    additionalInfo2: "*Процесс исцеления может проходить через обострение.",
  },
  family: {
    title: "9 колен рода",
    desc1:
      "9 колен рода — второй уровень оригинального метода Матрицы Судьбы. Если личная Матрица помогает понять себя и прийти к целостности личности, то родовая открывает следующий уровень — социально-родовое предназначение, отношения с семьёй и реализацию в социуме.",
    desc2:
      "На этом этапе мы индивидуально рассчитываем твои 9 колен рода, определяем родовые ключи и программы и начинаем переводить их из «минуса» в «плюс» через практики и этичные действия.",
    desc3:
      "Работа поможет: глубже проработать Арканы и программы, которые раскрываются на родовом уровне; увидеть повторяющиеся семейные сценарии и изменить то, что больше не хочется продолжать; по-новому посмотреть на родителей, близких и отношения внутри семьи; раскрыть ресурс своих корней для проявления, реализации и движения к целям; глубже понять своё социально-родовое предназначение и место среди других людей; создать новые причины для благоприятных изменений в своей жизни и следующих поколениях.",
    desc4:
      "Родовая Матрица не менее важна, чем личная. Это возможность не только глубже понять свои корни, но и взять из них ресурс для следующего этапа жизни — а иногда увидеть приятные перемены даже там, где долго ничего не сдвигалось.",
    videoMeeting: "Видеовстреча час + трансформация от >110 дней",
    additionalInfo1:
      "*Большое количество практик. Трансформации могут проходить через обострения",
  },
  awareness: {
    title: "Матрица осознанности",
    desc1:
      "«Матрица осознанности» — мой авторский формат углублённой работы с редкими расчётами оригинального метода Матрицы Судьбы. Он доступен тем, кто уже знаком со своей Целостной личной Матрицей, проработал её основные программы и готов идти дальше.",
    desc2:
      "Здесь начинается самое интересное: расчёты и уровни, которые практически не встречаются в открытых источниках. Мы выходим за пределы привычной Матрицы и исследуем более глубокие кармические программы, внутренние сценарии и дополнительные грани твоих Арканов. Некоторые расчёты ты уже мог видеть в моём калькуляторе — здесь мы наконец подробно разбираем и прорабатываем их.",
    desc3:
      "Это формат для тех, кому уже мало просто знать свою Матрицу. Ты получаешь возможность открыть редкие уровни оригинального метода, глубже исследовать себя и применить полученные знания на практике — а дальше посмотреть, какие изменения они принесут именно в твою жизнь.",
    listTitle: "Какие уровни входят:",
    listEl1: "Предназначение и матрица осознанности;",
    listEl2: "Предназначение и матрица внутренней кармы;",
    listEl3: "Матрица кристалла души;",
    listEl4: "Уровень «16 карм»;",
    listEl5: "Уровень «Демон — Жертва»",
    videoMeeting: "3 видеовстречи + трансформация от 60 дней",
    additionalInfo1:
      "*Уровень доступен сразу после «Целостной личной матрицы».",
  },
  prosperity: {
    title: "Звезда процветания",
    desc1:
      "«Чего я на самом деле хочу?», «Какой я хочу видеть свою жизнь дальше?», «И как превратить свои желания в реальные цели и действия?»",
    desc2:
      "Звезда Процветания — третий уровень оригинального метода Матрицы Судьбы, посвящённый соединению внутреннего и материального процветания. Мы определим твои желания и рассчитаем индивидуальную Звезду, чтобы увидеть:",
    desc3:
      "Этот уровень не только о том, как получить желаемое, но и о внутренней готовности к большему — мечтать, создавать, проявляться, принимать результаты своих действий и позволять себе процветать.",
    listEl1:
      "как твои идеи проходят путь от мысли и вдохновения до действия и результата;",
    listEl2:
      "что может мешать тебе двигаться к желаемому и где возникают личные препятствия;",
    listEl3:
      "что помогает или мешает тебе принимать больше и удерживать достигнутые результаты;",
    listEl4:
      "как проявленность, признание и отношения с материальным раскрываются через твои Арканы;",
    listEl5:
      "какие качества важно перевести из «минуса» в «плюс» и проработать через практики.",
    videoMeeting: "Видеовстреча + трансформация от 60 дней",
    additionalInfo1:
      "* Доступно только после прохождения уровня «9 колен рода»",
    additionalInfo2:
      "* Включает в себя большое количество практической работы.",
  },
  conscience: {
    title: "Осознанность",
    desc1:
      "Данная консультация вскрывает глубинную проблематику жизни и её исцеление, выход на новый уровень духовного развития. Проработка внутренней кармы. Открытие сердечной чакры, кристалла души и глубинных способностей личности.",
    desc2:
      "Данный расчёт показывает полный сценарий ситуаций в жизни человека и кармические истории, которые прорабатываются. В итоге человек получает алмазную огранку матрицы, то есть защиту судьбы.",
    listTitle: "Входят расчет таких матриц:",
    listEl1: "матрица души;",
    listEl2: "матрица внутренней кармы;",
    listEl3: "матрица осознанности;",
    listEl4: "матрица врат света.",
    videoMeeting: "Видеовстреча 90 минут + трансформация",
    additionalInfo1:
      "Требует минимального знакомства с базовым уровнем собственной матрицы!",
    additionalInfo2:
      "!Включает в себя большое количество практической и ритуальной работы. Процесс исцеления может проходить через обострение.",
  },
  coupleTherapy: {
    title: "Парная терапия",
    desc1:
      "Диагностика взаимоотношений с партнёром (вторая половинка, родители, дети, друзья, знакомые, братья/сестры, коллеги).",
    desc2:
      "Поможет выявить цели и проблемы коммуникации; точки роста; задачи партнёров; ресурсное состояние. Работа с негативными и позитивными качествами каждого из партнёров; проработка факторов, которые мешают гармоничному существованию партнёров; разбор плюсов и минусов совместимости.",
    desc3:
      "+ Заключительные рекомендации для эффективного решения проблем, достижения общих целей и баланса в партнёрстве по итогам терапии.",
    videoMeeting:
      "Личная встреча или видеовстреча от 3-х часов ( 1-2 перерыва по 10 минут) + трансформация для партнеров",
    warning: "*ТРЕБУЕТСЯ ПРИСУТСТВИЕ ДВУХ ПАРТНЁРОВ!",
  },
  game: {
    title: "Трансформационная игра “Кармические Путешествия”",
    desc1:
      "В игре можно исследовать практически любой жизненный вопрос через прошлое, настоящее и будущее и увидеть неочевидные причинно-следственные связи.",
    desc2:
      "Можно прийти с одним конкретным запросом, целью или исследовать сразу несколько сфер жизни: отношения, деньги, работу и реализацию, предназначение, личностное развитие, повторяющиеся ситуации и другие. Посмотреть, что происходит в каждой из них, и при необходимости вовремя скорректировать свои действия.",
    listTitle: "Игра помогает:",
    listEl1:
      "понять, почему возникла или повторяется ситуация и какие причины к ней привели;",
    listEl2: "увидеть, ты сейчас улучшаешь её или продолжаешь усугублять;",
    listEl3: "понять, что уже делаешь правильно, а где ошибаешься;",
    listEl4:
      "определить, что можно изменить, чтобы ситуация разрешилась или ты приблизился к своей цели",
    listEl5:
      "увидеть, какие возможности для желаемого результата уже созданы твоими прошлыми действиями.",
    listEl6:
      "посмотреть на привычную ситуацию с другой стороны и заметить то, чего раньше не видел;",
    listEl7:
      "получить больше внутренней ясности и спокойствия в отношении своего запроса.",

    videoMeeting: "Видеовстреча",
    meeting:
      "Встреча в г. Бар, Черногория (локация согласовывается с участниками)",
    person: "чел",
    groupGame: "Групповая игра (до 6 человек)",
    personalGame: "Индивидуальная игра",
  },
  parentChildren: {
    title: "Детско-родительские отношения",
    listTitle: "Данная консультация поможет:",
    listEl1: "понять себя и своего ребёнка;",
    listEl2: "выстроить правильную коммуникацию;",
    listEl3: "уделить внимание определённым качествам ребёнка;",
    listEl4: "направить в нужную сферу деятельности;",
    listEl5: "эффективно решать конфликтные ситуации;",
    listEl6: "выбрать верную модель поведения родителя;",
    listEl7: "узнать таланты, способности, задачи и ключевые энергии ребёнка.",
    videoMeeting:
      "Видеовстреча 60 - 90 минут + индивидуальные рекомендации для ребенка и детско-родительских отношений + трансформация для родителя исходя из запроса",
    additionalInfo1: "Матрица ребёнка, Совместимость 1 родителя с ребёнком",
    additionalInfo2:
      "Комплексная консультация: Счастливая семья (матрица ребёнка, совместимость ребёнка с каждым родителем, совместимость родителей)",
  },
  personalLife: {
    title: "Личная жизнь",
    listTitle: "Данная консультация поможет:",
    listEl1: "наладить личную жизнь;",
    listEl2: "найти вторую половинку;",
    listEl3: "понять какой для вас комфортный тип взаимоотношений;",
    listEl4: "прийти к взаимопониманию с партнером.",
    desc1:
      "Разбор личных качеств и почему не удается построить личную жизнь. Понять какой партнер подходит и какие потребности вам важно закрывать в отношениях.",
    desc2:
      "На трансформации будет возможность прокачать внутреннюю энергетику, усилить свои достоинства и проработать негативные установки, мешающие построить гармоничные отношения.",
    desc3: "Разбор матрицы совместимости с 1 – 2 партнерами",
    videoMeeting: "Видеовстреча 60 минут + трансформация 1 блок",
  },
  year: {
    title: "Прогноз на год",
    desc1:
      "Позволяет узнать свои энергии в прошлом, текущем или будущем году. Включает в себя прогностику на каждые 22 дня, где прописаны все ключи данного периода и дана вариативность, как позитивных, так и негативных событий.",
    desc2:
      "Раскрытие задач, возможностей, испытаний данного года. Денежные и любовные аспекты года и возможности их реализаций.",
    videoMeeting:
      "Видеовстреча 30 - 40 минут + файл с прогностикой на каждые 22 дня + материалы для гармонизации года на усмотрение мастера",
    additionalInfo2:
      "*Возможность обратиться к мастеру за дополнительными разъяснениями и рекомендациями в течение всего года.",
  },
};

export default modalsRu;
